export default __webpack_public_path__ + "static/media/three-dots-dark.6f2939d6.svg";